import { createStore } from "vuex";
import axios from "axios";
import Cookies from "js-cookie";





let _usertype = "";
let _permissionid = "";


let _firstName = "";
let _lastName = "";
let _email = "";
let _pathImage = "";
let _mobile = "";
let _employeeID = "";
let _MenuId = "";


try {
  _usertype = sessionStorage.getItem("usertype") || "";

  _permissionid = sessionStorage.getItem("permissionid") || "";
  _firstName = sessionStorage.getItem("firstName") || "";
  _lastName = sessionStorage.getItem("lastName") || "";
  _email = sessionStorage.getItem("email") || "";
  _pathImage = sessionStorage.getItem("pathImage") || "";
  _mobile = sessionStorage.getItem("mobile") || "";
  _employeeID = sessionStorage.getItem("employeeID") || "";
  _MenuId = sessionStorage.getItem("MenuId") || "";

} catch (ex) {
  // sessionStorage unavailable (e.g. private mode / disabled): keep empty defaults
  console.error(ex)
}








export default createStore({
  state: {
    status: "",
    token: Cookies.get("access_token") || "",
    userid: Cookies.get("userId") || "",
    usertype: _usertype,
    username: Cookies.get("username") || "",

    permissionid: _permissionid,
    firstName: _firstName,
    lastName: _lastName,
    email: _email,
    pathImage: _pathImage,
    mobile: _mobile,
    employeeID: _employeeID,
    MenuId: _MenuId,
    Snippet_StatusData: false,
    user: {},
    languages: "",
    fullName: "",
    groupSecurityID: null,
    isDrawerOpen: false, // Added for drawer state
  },
  mutations: {
    setSnippetStatus (state, status) {
      state.Snippet_StatusData = status
    },
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, user) {
      state.status = "success";
      state.token = user.token;
      state.userid = user.userId;
      state.permissionid = user.permissionId;
      state.usertype = user.userType.trim();
      state.username = user.username.trim();
      state.firstName = user.firstName;
      state.lastName = user.lastName;
      state.email = user.email;
      state.mobile = user.mobile;
      state.pathImage = user.pathImage;
      state.employeeID = user.employeeID;
      state.MenuId = user.MenuId;
      // eslint-disable-next-line no-console
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.userid = "";
      state.usertype = "";
      state.permissionid = "";
      state.firstName = "";
      state.lastName = "";
      state.email = "";
      state.mobile = "";
      state.pathImage = "";
      state.employeeID = "";
      state.MenuId = "";
    },
    SET_DRAWER_OPEN(state, payload) {
      state.isDrawerOpen = payload;
    },
  },
  actions: {
    login({
      commit,
    }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `Login/Login`,
          data: user,
          method: "POST"
        })
          .then(resp => {


            if (resp.data.status == 0) {
              const token = resp.data.data.token;
              const userId = resp.data.data.userId;
              const permissionId = resp.data.data.permissionId;
              const userType = resp.data.data.userType.trim();
              const user = resp.data.data;
              const userName = resp.data.data.username.trim();
              const firstName = resp.data.data.firstName;
              const lastName = resp.data.data.lastName;
              const email = resp.data.data.email;
              const mobile = resp.data.data.mobile;
              const pathImage = resp.data.data.pathImage;
              const employeeID = resp.data.data.employeeID;
              const MenuId = resp.data.data.menuId;
              sessionStorage.setItem("token", token);
              sessionStorage.setItem("userid", userId);
              sessionStorage.setItem("usertype", userType);
              sessionStorage.setItem("username", userName);
              sessionStorage.setItem("permissionid", permissionId);
              sessionStorage.setItem("firstName", firstName);
              sessionStorage.setItem("lastName", lastName);
              sessionStorage.setItem("email", email);
              sessionStorage.setItem("mobile", mobile);
              sessionStorage.setItem("pathImage", pathImage);
              sessionStorage.setItem("employeeID", employeeID);
              sessionStorage.setItem("MenuId", MenuId);

              // Add the following line:
              axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
              commit("auth_success", user);
              resolve(resp);
            } else {
              commit("auth_error");
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("userid");
              sessionStorage.removeItem("usertype");
              sessionStorage.removeItem("username");
              sessionStorage.removeItem("permissionid");
              sessionStorage.removeItem("firstName");
              sessionStorage.removeItem("lastName");
              sessionStorage.removeItem("email");
              sessionStorage.removeItem("mobile");
              sessionStorage.removeItem("pathImage");
              sessionStorage.removeItem("employeeID");
              sessionStorage.removeItem("MenuId");
              reject(resp.data.message);
            }
          })
          .catch(err => {
            commit("auth_error");
            reject(err);
          });
      });
    },



    logout({
      commit
    }) {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        commit("logout");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userid");
        sessionStorage.removeItem("usertype");
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("permissionid");
        sessionStorage.removeItem("firstName");
        sessionStorage.removeItem("lastName");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("mobile");
        sessionStorage.removeItem("pathImage");
        sessionStorage.removeItem("employeeID");
        sessionStorage.removeItem("MenuId");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    usertype: state => state.usertype,
    userid: state => state.userid,
    permissionid: state => state.permissionid,
    employeeID: state => state.employeeID,
    MenuId: state => state.MenuId,
    authStatus: state => state.status,
    groupSecurityID: state => state.groupSecurityID
  }
});